const t = "styles-module__mobileMenuGradientButton___G7BUa", e = {
  mobileMenuGradientButton: t
};
export {
  e as default,
  t as mobileMenuGradientButton
};
